module.exports = __webpack_public_path__ + "static/img/26.8a9efdf8.png";